export enum SensorActionTypes {
  GET_SENSORS = "@@SENSOR/GET_SENSORS",
  GET_SENSORS_SUCCESS = "@@SENSOR/GET_SENSORS_SUCCESS",
  GET_SENSORS_FAILURE = "@@SENSOR/GET_SENSORS_FAILURE",

  CREATE_SENSOR = "@@USER/CREATE_SENSOR",
  CREATE_SENSOR_SUCCESS = "@@SENSOR/CREATE_SENSOR_SUCCESS",
  CREATE_SENSOR_FAILURE = "@@SENSOR/CREATE_SENSOR_FAILURE",

  UPDATE_SENSOR = "@@SENSOR/UPDATE_SENSOR",
  UPDATE_SENSOR_SUCCESS = "@@SENSOR/UPDATE_SENSOR_SUCCESS",
  UPDATE_SENSOR_FAILURE = "@@SENSOR/UPDATE_SENSOR_FAILURE",

  UPDATE_SENSOR_STATUS = "@@SENSOR/UPDATE_SENSOR_STATUS",
  UPDATE_SENSOR_STATUS_SUCCESS = "@@SENSOR/UPDATE_SENSOR_STATUS_SUCCESS",
  UPDATE_SENSOR_STATUS_FAILURE = "@@SENSOR/UPDATE_SENSOR_STATUS_FAILURE",

  CLEAR_SENSORS = "@@SENSOR/CLEAR_SENSORS",
  SET_FILTER = "@@SENSOR/SET_FILTER",
}
